export const CONFIG = {
    API_HOST:  'https://api.mainroad.trade',
    PUBLIC_KEY: '-----BEGIN PUBLIC KEY-----\n' +
        'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAvQVvzOakAuSkZJlq1Vxv\n' +
        '2gf4oAYU/pd4np4Wg5SLF19kUOOZULZq+bcnPzjDaSFES9/E5fcJFuifFq1d8b0t\n' +
        'K/OM2LPPOIevj8kAe3z7DKZIZsuMCSJ3ajj87sdO+NMX8virMsr44lakLMubrX9V\n' +
        '1eM4IkecE7MoDdzDnhcNiTtQEclRcGfZJ3yFCbCts7Bl35bwlCai7xtzuTt+3M7r\n' +
        'joenZC0lU/eRrk9tZGe8oOpEgz7OMMwlrx/Rs2NKYBgO3r2mfTVG1tH4C4WD1I3P\n' +
        'a97ZTEc7RedxxvSu0WdSJHVQWitxwm6Wv2cTweCdbYfeIdfi1yVcPPMPmE8/z22l\n' +
        'PQIDAQAB\n' +
        '-----END PUBLIC KEY-----',
    LIVE_CHAT_LICENCE: '16702986',
    YANDEX_METRIKA_CODE: 99899864
}